import * as React from "react"
import {ToggleButtonSeeker} from "@ui-seeker/core";

import {RECORD_COUNT_KPI} from "../@constants";


const TOP_TABS = [
	{ value: RECORD_COUNT_KPI.AVG_PRICE, label: 'Avg Price' },
    { value: RECORD_COUNT_KPI.MAX_PRICE, label: 'Max Price' },
    { value: RECORD_COUNT_KPI.MIN_PRICE, label: 'Min Price' },
    { value: RECORD_COUNT_KPI.PRODUCTS, label: 'Nº Products' }
]

export default function CatalogueAnalyzerGroupedVsSiteToggleButton({value, handleChange}) {
    return <ToggleButtonSeeker
        value={value}
        tabs={TOP_TABS}
        onChange={handleChange}
    />
}